const state = {
  widgetImageGallery : {
    indexSilde : 0,
    widgetId : undefined
  },
  widgetInteractive:{
    status : 'regular',
    widgetId : undefined
  }
}

const getters = {
  widgetImageGallery: () => {
    return state.widgetImageGallery;
  },
  widgetInteractive: () => {
  return state.widgetInteractive;
  },

}
const actions = {
  setWidgetImageGallery({ commit , dispatch },  data ) {
    commit('SET_WIDGET_IMAGE_GALLERY',  data );
    dispatch("design/frameTool/syncWidgetImageGallery", {
      data,
    }, { root: true })
  },
  setWidgetInteractive({ commit , dispatch },  data ) {
    commit('SET_WIDGET_INTERACTIVE',  data );
    dispatch("design/frameTool/syncWidgetInteractive", {
      data,
    }, { root: true })
  },
}
const mutations = {
  SET_WIDGET_IMAGE_GALLERY(state, data) {
    const newObject = { ...state.widgetImageGallery, ...data }
    Object.keys(newObject).forEach(key => {
      state.widgetImageGallery[key] = newObject[key]
    })
  },
  SET_WIDGET_INTERACTIVE(state, data) {
    const newObject = { ...state.widgetInteractive, ...data }
    Object.keys(newObject).forEach(key => {
      state.widgetInteractive[key] = newObject[key]
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};